module.exports = __webpack_public_path__ + "assets/img/3.65f782e2.jpg";